export default {
    severity_outcome_1: 'Asymptomatic',
    severity_outcome_2:
        'Symptomatic; Apparent; Non-hospitalized cases; Negative for post-dengue chronic fatigue syndrome cases',
    severity_outcome_3:
        'Symptomatic; Apparent; Non-hospitalized cases; Positive for post-dengue chronic fatigue syndrome cases',
    severity_outcome_4: 'Symptomatic; Apparent; Non-hospitalized cases; Deaths',
    severity_outcome_5:
        'Symptomatic; Apparent; Hospitalized cases; Negative for post-dengue chronic fatigue syndrome cases',
    severity_outcome_6:
        'Symptomatic; Apparent; Hospitalized cases; Positive for post-dengue chronic fatigue syndrome cases',
    severity_outcome_7: 'Symptomatic; Apparent; Hospitalized cases; Deaths',
    severity_outcome_8:
        'Symptomatic; Apparent; Non-hospitalized cases; Negative for post-dengue chronic fatigue syndrome cases',
    severity_outcome_9:
        'Symptomatic; Apparent; Non-hospitalized cases; Positive for post-dengue chronic fatigue syndrome cases',
    severity_outcome_10: 'Symptomatic; Apparent; Non-hospitalized cases; Deaths',
    severity_outcome_11:
        'Symptomatic; Apparent; Hospitalized cases; Negative for post-dengue chronic fatigue syndrome cases',
    severity_outcome_12:
        'Symptomatic; Apparent; Hospitalized cases; Positive for post-dengue chronic fatigue syndrome cases',
    severity_outcome_13: 'Symptomatic; Apparent; Hospitalized cases; Deaths',
    severity_outcome_14:
        'Symptomatic; Inapparent; Negative for post-dengue chronic fatigue syndrome cases',
    severity_outcome_15:
        'Symptomatic; Inapparent; Positive for post-dengue chronic fatigue syndrome cases',
    severity_outcome_16: 'Symptomatic; Inapparent; Deaths',
    severity_outcome_17:
        'Symptomatic; Inapparent; Negative for post-dengue chronic fatigue syndrome cases',
    severity_outcome_18:
        'Symptomatic; Inapparent; Positive for post-dengue chronic fatigue syndrome cases',
    severity_outcome_19: 'Symptomatic; Inapparent; Deaths',
};
